<template>
  <section>
    <div ref="header">
      <search-input v-model="queryForm.keyword" placeholder-word="请输入车牌号码" @on-search="search"></search-input>
    </div>

    <scroller
      class="register-car-scroller"
      v-model="status"
      lock-x
      scrollbar-y
      use-pullup
      use-pulldown
      :height="scrollerHeight"
      @on-pullup-loading="loadMore"
      @on-pulldown-loading="getData"
      :pullup-config="{content:'',upContent:'',downContent:'',loadingContent:'加载中...'
      }"
      :pulldown-config="{content:'',upContent:'',downContent:'',loadingContent:'更新中...'
      }"
      v-if="totalCount">
      <group>
        <label :for="'radio_' + index" v-for="(item, index) in carOptions" class="weui_cell weui_cell_radio weui_check_label all_list" :key="index">
          <div class="weui_cell_bd weui_cell_primary">
            <p class="title">{{ item.plate_number }} <img :src="item.brand_image_url" alt="" v-if="item.brand_image_url"></p>
            <div class="show-time">
              <span class="store-time time">进店：{{item.visited_at | hideSecond}} {{!item.is_entered_workshop ? '（未进车间）': ''}}</span>
            </div>
          </div>
          <div class="weui_cell_ft">
            <div class="identifications">
              <span class="identification non-store-tip" v-if="!item.is_owner">非本店</span>
              <span class="identification" v-if="item.is_self_brand">本品</span>
            </div>
            <div class="register-car-list-radio">
              <input type="radio" :id="'radio_' + index" v-model="carPlateNumber" class="weui_check" :value="item.plate_number">
              <span class="weui_icon_checked"></span>
            </div>
          </div>
        </label>
      </group>
    </scroller>
  </section>
</template>
<script>
import {
  Scroller,
  Group
} from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'
export default {
  components: {
    SearchInput,
    Scroller,
    Group
  },
  data () {
    return {
      carOptions: [],
      carPlateNumber: '', // 车辆的车牌号
      status: {
        pulldownStatus: 'default'
      },
      queryForm: {
        page: 1,
        count: 10,
        is_enter_workshop: 0,
        keyword: ''
      },
      totalPage: 0,
      totalCount: 0,
      scrollerHeight: ''
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
  },
  watch: {
    carPlateNumber (newVal) {
      let from = this.$route.query.from
      this.$store.dispatch('UPDATE_CAR_REGISTER_INFO', Object.assign({}, this.$store.state.carRegister.carInfo, {
        workshop_plate_number: this.carPlateNumber
      }))
      this.$router.push({
        path: from,
        query: {
          type: '2' // 进车间
        }
      })
    }
  },
  filters: {
    // 隐藏日期中的秒
    hideSecond(dateStr) {
      return dateStr ? dateStr.replace(/:\d{2}$/, '') : '--'
    }
  },
  methods: {
    search() {
      this.queryForm.page = 1
      this.totalCount = 0
      this.totalPage = 0
      this.getData()
    },
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.barriergate.getAllFlowList(this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.carOptions = data.visits
          this.totalCount = data.total_count
          this.totalPage = parseInt((this.totalCount + count - 1) / count)
          this.status.pulldownStatus = 'default'
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        this.queryForm.page++
        this.$rest.barriergate.getAllFlowList(this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalCount = data.total_count
            this.totalPage = parseInt((this.totalCount + count - 1) / count)
            this.carOptions.push(...data.visits)
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    }
  }
}
</script>

<style lang="less">
  @w2: 75rem;
  .register-car-scroller {
    .all_list {
      position: relative;
      .title {
        line-height: 1;
        margin-top: 10/@w2;
        font-size: 36/@w2;
        img {
          width: 35/@w2;
          height: 35/@w2;
        }
      }
      .show-time {
        font-size: 26/@w2;
        color: #6b6b6b;
      }

      .identifications {
        position: absolute;
        display: flex;
        width: 120px;
        height: 30px;
        right: 30/@w2;
        top: 0;
        justify-content: flex-end;
      }
      .identification {
        display: block;
        width: 100/@w2;
        height: 50/@w2;
        line-height: 50/@w2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        text-align: center;
        font-size: 26/@w2;
        background-color: #5890ff;
        color: #fff;
      }
      .non-store-tip {
        margin-right: 20/@w2;
      }
    }
  }

  .register-car-scroller {
    background-color: #fff;
  }

  .register-car-list-radio {
    .weui_icon_checked {
      display: block;
      width: 32/@w2;
      height: 32/@w2;
      border: 2/@w2 solid #e7e7e9;
      border-radius: 50%;
      box-sizing: border-box;
    }
    .weui_check:checked + .weui_icon_checked {
      position: relative;
      border: 2/@w2 solid #509eff;
    }
    .weui_check:checked + .weui_icon_checked:before {
      display: block;
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 20/@w2;
      height: 20/@w2;
      margin: auto;
      border-radius: 50%;
      background-color: #509eff;
    }
  }
</style>
